import { API_WHATSAPP_CONTENTS, WhatsAppContents } from 'services/whats-app-contents';
import { useCurrentUser } from 'components/hooks';
import { useAppSelector } from 'store';
import { useMemo } from 'react';
import { generateDynamicQuery } from 'utils/service';
import { mergeFilters } from 'utils/dynamic-helpers';
import { useSource } from 'AurionCR/components';
import { selectLanguageID } from 'store/languages';

export type Template = Pick<WhatsAppContents, 'id' | 'title' | 'templateKey' | 'variables'>;

export const useSourceWhatsAppTemplates = () => {
  const { userEmployeeProfilePermission } = useCurrentUser();
  const languageID = useAppSelector(selectLanguageID);
  const userEmployeeProfilePermissionID = userEmployeeProfilePermission?.id;

  const query = useMemo(
    () =>
      generateDynamicQuery({
        select: ['id', 'title', 'variables', 'templateKey'].join(','),
        orderBy: ['title asc'].join(','),
        filter: mergeFilters(
          `languageID=="${languageID}"`,
          userEmployeeProfilePermissionID &&
            `userEmployeeProfilePermissionWhatsAppContents.any(k =>k.userEmployeeProfilePermissionID=="${userEmployeeProfilePermissionID}")`,
        ).join('&&'),
      }),
    [languageID, userEmployeeProfilePermissionID],
  );

  return useSource<Template>(`${API_WHATSAPP_CONTENTS.GET_ALL_DYNAMIC}?${query}`);
};
